import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { templates } from './templates';
import './styles/pages.css';

const TemplateSelect = () => {
  const navigate = useNavigate();

  const handleSelect = (templateId) => {
    navigate(`/Playground/Inviteapp/create/${templateId}`);
  };

  return (
    <div className="template-select-page">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        Choose Your Template {'\uD83D\uDC8C'}
      </motion.h1>
      <p className="subtitle">Pick the perfect vibe for your irresistible invite!</p>

      <div className="template-grid">
        {Object.values(templates).map((template, index) => (
          <motion.div
            key={template.id}
            className="template-card"
            style={{ background: template.colors.background }}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.15 }}
            whileHover={{ scale: 1.03, y: -5 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => handleSelect(template.id)}
          >
            <div className="template-preview">
              <img
                src={template.preview}
                alt={template.name}
                className="preview-image"
                style={{ width: 120, height: 120, objectFit: 'contain' }}
              />
            </div>

            <h3 style={{ color: template.colors.primary }}>{template.name}</h3>
            <p className="template-description">{template.description}</p>
            <button
              className="select-button"
              style={{
                background: `linear-gradient(135deg, ${template.colors.primary}, ${template.colors.secondary})`,
              }}
            >
              Select This One
            </button>
          </motion.div>
        ))}
      </div>

      <button className="back-button" onClick={() => navigate('/Playground/Inviteapp')}>
        {'\u2190'} Back to Home
      </button>
    </div>
  );
};

export default TemplateSelect;
